/**
 * 创建样式
 * */
var createStyleSheet = (function () {
    var isCreateStyleSheet = document.createStyleSheet && navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1;
    return function(styleStr) {
        if(isCreateStyleSheet){
            var s = document.createStyleSheet();
            var rules =  styleStr.replace(/\/\*[^\*]*\*\//g, "").replace(/@[^{]*\{/g, '').match(/[^\{\}]+\{[^\}]+\}/g);
            for(var i = 0; i < rules.length; i++) {
                var m = rules[i].match(/(.*)\s*\{\s*(.*)\}/);
                if(m) {
                    try {
                        s.addRule(m[1], m[2]);
                    } catch(e) {
                    }
                }
            }
        }else{
            var style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML=styleStr;
            document.getElementsByTagName('HEAD')[0].appendChild(style);
        }
    }
})();
module.exports = createStyleSheet;